import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import VideoPlaceholder from '../placeholder';

import { getDeviceType, getTimeString } from '../../../lib/utils';

const KalturaPlayerWrapper = styled.div`
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;

    & iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100% !important;

        opacity: ${(props) => (props.showThumb ? '0' : '1')};
    }
`;

const KalturaPlayer = ({ videoId, title, onPlayVideo = () => {}, autoPlay = false }) => {
    const [duration, setDuration] = useState();
    const [showThumb, setShowThumb] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [kdp, setKdp] = useState();
    useEffect(() => {
        window.kWidget.embed({
            targetId: `myEmbedTarget_${videoId}`,
            wid: '_362071',
            uiconf_id: '2189291',
            entry_id: videoId,
            flashvars: {
                // flashvars allows you to set runtime uiVar configuration overrides.
                autoPlay: false,
            },
            params: {
                // params allows you to set flash embed params such as wmode, allowFullScreen etc
                wmode: 'transparent',
            },
            readyCallback: (playerId) => {
                let kdp = document.getElementById(playerId);
                setKdp(kdp);
                setLoaded(true);

                kdp.addJsListener('metadataReceived', () => {
                    setDuration(getTimeString(kdp.evaluate('{duration}')));
                });
            },
        });
    }, [videoId, setKdp, setLoaded, setDuration]);

    useEffect(() => {
        if (loaded && autoPlay) {
            setShowThumb(false);

            if (getDeviceType() === 'DESKTOP') {
                kdp.sendNotification('doPlay');
            }

            onPlayVideo();
        }
    }, [loaded, autoPlay, kdp, onPlayVideo]);

    const playVideo = (event) => {
        if (loaded) {
            event.stopPropagation();
            setShowThumb(false);
            kdp.sendNotification('doPlay');
            onPlayVideo();
        }
    };

    return (
        <KalturaPlayerWrapper showThumb={showThumb}>
            <div id={`myVideoContainer_${videoId}`} itemProp="video" itemScope={true} itemType="https://schema.org/VideoObject">
                <div id={`myEmbedTarget_${videoId}`}></div>
            </div>
            {showThumb && loaded && (
                <VideoPlaceholder
                    title={title}
                    duration={duration}
                    imageSource={`https://cfvod.kaltura.com/p/243342/sp/24334200/thumbnail/entry_id/${videoId}/version/100007/width/1280/height/720`}
                    onClick={(event) => playVideo(event)}
                    disabled={!loaded}
                />
            )}
        </KalturaPlayerWrapper>
    );
};

KalturaPlayer.propTypes = {
    videoId: PropTypes.string,
    title: PropTypes.string,
    onPlayVideo: PropTypes.func,
    autoPlay: PropTypes.bool,
};

export default KalturaPlayer;
